module.exports = __webpack_public_path__ + "static/media/4.ebec6cc0.jpeg";